/* An A/B harness toggling compositor-layer promotion of `.bloom`/`.glow`
   (WAT-11671), not a design state. No OTHER --gcc-* property may be
   @property-registered — two are, and AC21 needs them. Figures in the mdx. */

const PROFILE_ATTRIBUTE = "data-gcc-profile";

/** The query parameter that makes the same choice without touching the DOM. */
const PROFILE_PARAMETER = "gccProfile";

/** The allowlist backing the exported type. */
const PROFILE_NAMES = ["current", "noPromote"] as const;

export type GrowCardCarouselProfileName = (typeof PROFILE_NAMES)[number];

/** The shipped rendering. */
export const DEFAULT_GROW_PROFILE: GrowCardCarouselProfileName = "current";

function isProfileName(value: unknown): value is GrowCardCarouselProfileName {
  return PROFILE_NAMES.some(name => name === value);
}

/**
 * The profile in force, from the query parameter or the nearest ancestor
 * carrying the attribute; unrecognised or server-side resolves to `current`.
 *
 * The section's data-gcc-profile is an output, never an input — this
 * searches from its PARENT.
 */
export function resolveGrowProfile(section: Element | null): GrowCardCarouselProfileName {
  if (typeof window === "undefined") {
    return DEFAULT_GROW_PROFILE;
  }

  const requested =
    new URLSearchParams(window.location.search).get(PROFILE_PARAMETER) ||
    section?.parentElement?.closest(`[${PROFILE_ATTRIBUTE}]`)?.getAttribute(PROFILE_ATTRIBUTE);

  return isProfileName(requested) ? requested : DEFAULT_GROW_PROFILE;
}
